module.exports = __webpack_public_path__ + "static/media/work-commute-error-icon.8e3929b3.svg";